import * as React from 'react';

import * as styles from './styles.css';

export const AlertNotFoundIcon: React.FC = () => {
  return <div className={styles['not-found-icon']} />;
};
